import { defineComponent as _defineComponent } from 'vue'
import { useGtm } from '@gtm-support/vue2-gtm';
import {
  onMounted, ref, watch,
} from 'vue';
import { useRoute } from 'vue-router/composables';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DirtyModalAmexPayback',
  emits: ['userAnswered'],
  setup(__props, { emit }) {


const form = store.state.customer?.form;

// Google Tag Manager
const gtm = useGtm();

// Google Tag Manager Event
function triggerGtmEvent(event: string): void {
  gtm?.trackEvent({
    event,
    campaignName: 'AmexPayback',
  });
}
const route = useRoute();
const modal = ref(false);

const yes = () => {
  modal.value = false;

  form.isPaybackCustomer = true;
  form.redeemStartingPoint = { source: 'popup', campaignName: 'AmexPayback' };

  emit('userAnswered');
  triggerGtmEvent('advertismentPopupAccepted');
};

const no = () => {
  modal.value = false;
  form.isPaybackCustomer = false;
  emit('userAnswered');
};

onMounted(() => {
  setTimeout(() => {
    if (route.name !== 'shopDetails') {
      modal.value = true;
    }
  }, 250);
});

watch(modal, (val) => {
  if (val === false) {
    triggerGtmEvent('advertismentPopupDeclined');
  }
});

return { __sfc: true,form, gtm, triggerGtmEvent, route, modal, emit, yes, no }
}

})